<!--
* @Author: lxh
* @Date: 2022-09-07
* @LastEditTime: 2022-09-07
* @Description: 自定义全选select
-->
<template>
  <el-select @visible-change="openSelect" @change="selectChange" v-model="myValue" :multiple="multiple" :filterable="filterable"
    :filter-method="filterHandle" reserve-keyword
    collapse-tags :placeholder="placeholder? placeholder: '全部'" class="w200 shopStyle">
    <div class="operateSelect" v-if="multiple">
      <span @click="selectAll(true)">全选（{{myValue.length}}）</span>
      <span @click="selectAll(false)">清空</span>
    </div>
    <el-option v-for="(item, index) in filterData" :key="itemKey(item, 'value') + '_' + index" :label="itemKey(item, 'label')" :value="itemKey(item, 'value')">
    </el-option>
  </el-select>
</template>

<script>

export default {
  props: {
    filterable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    optionQuery: {
      type: Object,
      default: () => {
        return {
          label: '',
          value: ''
        }
      }
    },
    placeholder: {
       type: String,
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array | String | Number | null | undefined
    },
    mutex: { // 互斥和其他选项不可同时存在的value
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myValue: null,
      filterData: []
    };
  },
  watch: {
    value: {
      handler(val) {
        this.myValue = val
      },
      immediate: true
    },
    options: {
      handler(val) {
        this.filterData = val
      },
      immediate: true
    },
  },
  methods: {
    selectChange() {
      console.log(this.myValue)
      if (this.myValue.length && this.mutex.includes(this.myValue[this.myValue.length -1])) {
        this.myValue = this.myValue.filter(item => this.mutex.includes(item))
      } else if (this.myValue.length && !this.mutex.includes(this.myValue[this.myValue.length -1])) {
        this.myValue = this.myValue.filter(item => !this.mutex.includes(item))
      }
      this.$emit('input', this.myValue)
      this.$emit('change')
    },
    selectAll(val) {
      let arr = []
      this.filterData.forEach(item => {
        if (this.optionQuery.value) {
          arr.push(item[this.optionQuery.value])
        } else {
          arr.push(item)
        }
      })
      if (val) {
        this.myValue = [...new Set([...this.myValue, ...arr].filter(item => !this.mutex.includes(item)))]
      } else {
        this.myValue = []
      }
      this.$emit('input', this.myValue)
      this.$emit('change')
    },
    filterHandle(val) {
      console.log(val, this.options, 'filter')
      this.filterData = this.options.filter(item => {
        if (this.optionQuery.label) {
          return item[this.optionQuery.label].includes(val)
        } else {
          return item && item.includes(val)
        }
      })
    },
    openSelect() {
      this.filterData = this.options
    },
    itemKey(val, type) {
      if (this.optionQuery.label && this.optionQuery.value) {
        return type === 'value' ? val[this.optionQuery.value] : val[this.optionQuery.label]
      } else {
        return val
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.operateSelect{
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  color: #1890ff;
  span{
    cursor: pointer;
    font-size: 14px;
    line-height: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/selectAutoModel/index.vue